import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MinusCircleOutlined } from "@ant-design/icons";
import { Button, Form, Input, Space } from "antd";
import { EUserRole, TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../others/i18n.js";
import { spacing } from "../../../../../styles/spacing.js";
import { getFieldNameTranslated } from "../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../formFieldVisibilityWrapper.js";
import { WhenOnOfTip } from "./when-one-of/when-one-of-tip.js";
function FormFieldTemplateRecommendedWhenOneOfList() {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: TemplateMetaDataField.RecommendedWhenOneOf,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(TemplateMetaDataField.RecommendedWhenOneOf, t),
            children: /*#__PURE__*/ _jsx(Form.List, {
                name: TemplateMetaDataField.RecommendedWhenOneOf,
                children: (fields, { add, remove })=>/*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Form.Item, {
                                extra: t("Template will be recommended in scanner when at least one condition is true."),
                                children: /*#__PURE__*/ _jsxs(Space, {
                                    size: "small",
                                    children: [
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "default",
                                            onClick: ()=>add(),
                                            style: {
                                                maxWidth: "10rem"
                                            },
                                            children: t("Add")
                                        }),
                                        /*#__PURE__*/ _jsx(WhenOnOfTip, {})
                                    ]
                                })
                            }),
                            fields.map((field, index)=>/*#__PURE__*/ _jsxs("span", {
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Item, {
                                            ...field,
                                            validateTrigger: [
                                                "onChange",
                                                "onBlur"
                                            ],
                                            noStyle: true,
                                            children: /*#__PURE__*/ _jsx(Input, {
                                                placeholder: "is-wordpress-plugin-or-theme-active:some-slug",
                                                style: {
                                                    width: "90%"
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(MinusCircleOutlined, {
                                            style: {
                                                marginLeft: spacing.layout.content.padding
                                            },
                                            className: "dynamic-delete-button",
                                            onClick: ()=>remove(field.name)
                                        })
                                    ]
                                }, `recommended-item-${index}`))
                        ]
                    })
            })
        })
    });
}
export { FormFieldTemplateRecommendedWhenOneOfList };
